import React from 'react';
import { MARQUEE_ITEMS } from '../mock';

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="relative border-y border-[var(--line)] bg-[var(--bg-alt)] py-7 overflow-hidden">
      <div className="marquee">
        {items.map((item, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="font-display text-[clamp(1.6rem,3vw,2.4rem)] text-[#c3cbdb] px-8">{item}</span>
            <span className="text-[var(--accent)] text-lg rotate-45">&#9670;</span>
          </span>
        ))}
      </div>
    </div>
  );
}
